import axiosInstance from "./AxiosInstance";

export default {
    get() {
        return axiosInstance({
            method: "get",
            url: "/home",
        });
    },
};
